export const TYPE_INTERNET = 'internet' as const;
export const TYPE_PARTNERS = 'partners' as const;
export const TYPE_PRINT = 'print' as const;
export const TYPE_BLOG = 'blog' as const;
